<div class="question">

  <!-- Step 1 - download the template -->
  <div class="help-slide help-slide--lg help-slide--card">
    <div class="help-slide__thumb">
      <img src="assets/img/csv-download.svg" class="img-fluid" alt="">
    </div>

    <div class="help-slide__content">
      <small class="help-slide__content-meta">STEP 01</small>
      <h5>Download the template</h5>
      <p>
        Download our template file and add your data.
      </p>

      <div class="help-slide__content-btn">
        <button type="button" class="button button--primary" (click)="downloadTemplate()">Download the template</button>
      </div>
    </div>
  </div>

  <!-- Step 2 - upload the CSV -->
  <div class="help-slide help-slide--lg help-slide--card">
    <div class="help-slide__thumb">
      <img src="assets/img/csv-upload.svg" class="img-fluid" alt="">
    </div>

    <div class="help-slide__content">
      <small class="help-slide__content-meta">STEP 02</small>
      <h5>Upload your CSV</h5>
      <p>
        Once you&rsquo;ve correctly formatted your CSV upload it here to import the details being covered
      </p>

      <div class="help-slide__content-btn">
        <button type="button" class="button button--primary" [disabled]="readOnly" (click)="openUploadModal()">
          {{ importedCount ? 'Re-upload the CSV' : 'Upload the CSV' }}
        </button>
      </div>

      @if (importedCount) {
        <p class="mt-10 mb-0">
          <small class="font-medium">{{ importedCount }} {{ importedCount === 1 ? 'row' : 'rows' }} imported</small>
        </p>
      }
    </div>
  </div>

</div>


<!-- mini modal (uploader) -->
<div class="modal fade modal--mini" [id]="uniqueId + '-upload'" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Upload your CSV</h4>
          <button class="modal-mini__heading-close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="form-group form-group--sm">
            <label class="custom-upload custom-upload--docs mb-0" [for]="uniqueId + '-file'">
              <div class="custom-upload__dropzone dz-default">
                <div class="custom-upload__thumb">
                  <img src="assets/img/upload-documents.svg" alt="">
                </div>
                <div class="custom-upload__instructions">
                  <p>Tap to add files</p>
                  <svg class="icon">
                    <use xlink:href="#upload"></use>
                  </svg>
                  @if (!fileName) {
                    <p>Drag &amp; drop files here or <strong>browse</strong></p>
                  }
                  @if (fileName) {
                    <p><strong>{{ fileName }}</strong></p>
                  }
                </div>
              </div>
            </label>
            <input type="file" class="d-none" [id]="uniqueId + '-file'" accept=".csv,text/csv" (change)="onFileSelected($event)">
          </div>

          @if (fileError) {
            <div class="notice notice--error notice--sm">
              <div class="notice__content">
                <svg class="icon">
                  <use xlink:href="#warning"></use>
                </svg>
                <p>{{ fileError }}</p>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="modal-mini__button">
        <div class="container-fluid">
          <button type="button" data-dismiss="modal" class="button button--secondary">Cancel</button>
          <button type="button" class="button button--primary" [disabled]="!csvHeaders.length" (click)="submitUpload()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- map columns modal -->
<div class="modal fade modal--fs" [id]="uniqueId + '-map'" data-backdrop="static" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-header">
        <div class="container-fluid">
          <div class="modal-nav">
            <div class="modal-nav__title">
              <h5>Map your columns</h5>
            </div>
            <div class="modal-nav__actions">
              <button class="modal-nav__actions-close" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      <div class="modal-body pt-0">

        @if (unmappedRequiredColumns.length) {
          <div class="notice notice--error notice--sm mb-15">
            <div class="notice__content">
              <svg class="icon">
                <use xlink:href="#warning"></use>
              </svg>
              <p>Please map the following columns: <strong>@for (column of unmappedRequiredColumns; track column; let last = $last) {
                {{ column.label }}{{ last ? '' : ', ' }}
              }</strong></p>
            </div>
          </div>
        }

        <div class="table__wrap table__wrap--map">
          <table class="table table--map">
            <thead>
              <tr class="table-map-row">
                @for (header of csvHeaders; track header; let csvIndex = $index) {
                  <th>
                    <select class="form-control form-control--sm" [(ngModel)]="columnMapping[csvIndex]">
                      <option [ngValue]="-1">Ignore</option>
                      @for (column of columns; track column; let targetIndex = $index) {
                        <option [ngValue]="targetIndex">
                          {{ column.label }}
                        </option>
                      }
                    </select>
                  </th>
                }
              </tr>
              <tr class="table-title-row">
                @for (header of csvHeaders; track header) {
                  <th>{{ header }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of mappingPreviewRows; track row) {
                <tr>
                  @for (header of csvHeaders; track header; let csvIndex = $index) {
                    <td>{{ row[csvIndex] }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-tray">
        <div class="modal-tray__btns">
          <button class="button button--secondary" data-dismiss="modal">Cancel</button>
          <button class="button button--primary" [disabled]="unmappedRequiredColumns.length" (click)="confirmMapping()">Next</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- review and edit modal -->
<div class="modal fade modal--fs" [id]="uniqueId + '-review'" data-backdrop="static" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <header class="modal-header">
        <div class="container-fluid">
          <div class="modal-nav">
            <div class="modal-nav__title">
              <button class="modal-nav__title-back" (click)="backToMapping()">
                <svg class="icon">
                  <use xlink:href="#arrow-left"></use>
                </svg>
              </button>
              <h5>Review and edit</h5>
            </div>
            <div class="modal-nav__actions">
              <button class="button button--primary" (click)="saveImport()">Save &amp; Import</button>
              <button class="modal-nav__actions-close" data-dismiss="modal">
                <svg class="icon">
                  <use xlink:href="#close-medium"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      <div class="modal-body pt-0">

        <div class="table-actions">
          <div class="table-actions__search">
            <div class="input-wrap">
              <div class="input-wrap-prepend">
                <div class="input-wrap-icon">
                  <svg class="icon">
                    <use xlink:href="#search"></use>
                  </svg>
                </div>
              </div>
              <input type="search" class="form-control form-control--sm" placeholder="Search"
                [(ngModel)]="searchTerm" (ngModelChange)="onSearchChanged()">
              </div>
            </div>
            <div class="table-actions__other">
              <button class="button button--secondary" (click)="addRow()">Add row</button>
              <div class="dropdown">
                <button class="icon-button icon-button--lg icon-button--outline" data-toggle="dropdown">
                  <svg class="icon"><use xlink:href="#more"></use></svg>
                </button>
                <div class="dropdown-menu">
                  <a href="javascript:void(0)" class="dropdown-item" (click)="exportCsv()">
                    <span>Export as CSV</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="table__wrap table__wrap--map">
            <table class="table table--map table--map-review">
              <thead>
                <tr class="table-title-row">
                  <th class="cell-min">&nbsp;</th>
                  @for (column of columns; track column) {
                    <th>{{ column.label }}</th>
                  }
                  <th class="cell-min">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                @for (row of pagedRows; track row) {
                  <tr [class.table-row-added]="row.added">
                    <td class="cell-min">
                      <label class="selection">
                        <input type="checkbox" [(ngModel)]="row.selected" [disabled]="showValidationError">
                        <div class="selection__inner">
                          <div class="selection__main">
                            <div class="selection__content">
                              <div class="selection__indi"><span></span></div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </td>
                    @for (column of columns; track column; let columnIndex = $index) {
                      <td>
                        <input type="text" class="form-control form-control--md" [class.has-error]="row.errors[columnIndex]"
                          [(ngModel)]="row.values[columnIndex]" (ngModelChange)="onCellChanged(row, columnIndex)">
                        </td>
                      }
                      <td class="cell-min">
                        <button class="icon-button" type="button" (click)="deleteRow(row)">
                          <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

          </div>
          <div class="modal-tray">
            <div class="table-pagination table-pagination--map">
              <div class="table-pagination__controls">
                <em>{{ filteredRows.length ? ((page - 1) * pageSize + 1) : 0 }}-{{ page * pageSize > filteredRows.length ? filteredRows.length : page * pageSize }}</em>
                of {{ filteredRows.length }}
              </div>
              <div class="table-pagination__selection" [class.d-none]="!selectedCount">
                <strong>{{ selectedCount === 1 ? '1 item selected' : selectedCount + ' items selected' }}</strong>
                <button class="link" (click)="cancelSelection()">
                  <svg class="icon">
                    <use xlink:href="#cancel"></use>
                  </svg>
                  <span>Cancel selection</span>
                </button>
                <button class="link" (click)="deleteSelection()">
                  <svg class="icon">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                  <span>Delete</span>
                </button>
              </div>
              <div class="table-pagination__error" [class.d-none]="!showValidationError">
                <div class="notice notice--error notice--sm">
                  <div class="notice__content">
                    <svg class="icon">
                      <use xlink:href="#warning"></use>
                    </svg>
                    <p>Please correct any errors before proceeding.</p>
                  </div>
                </div>
              </div>
              <div class="table-pagination__navs">
                <button class="icon-button" [disabled]="page === 1" (click)="setPage(page - 1)">
                  <svg class="icon"><use xlink:href="#chevron-left-small"></use></svg>
                </button>
                <span>{{ page }} / {{ totalPages }}</span>
                <button class="icon-button" [disabled]="page === totalPages" (click)="setPage(page + 1)">
                  <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
